import { render, staticRenderFns } from "./IndividualCourseStudentRankingPage.vue?vue&type=template&id=1cbd24d5&scoped=true"
import script from "./IndividualCourseStudentRankingPage.vue?vue&type=script&lang=js"
export * from "./IndividualCourseStudentRankingPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cbd24d5",
  null
  
)

export default component.exports